import { useParams } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import React from "react";
import { _delete } from "../../Api";
import { toast } from "react-toastify";

export default function RemoveFloorplanDialog(props) {
  const dialogClose = props.dialogClose;
  const spMerchantId = Number.parseInt(useParams().spMerchantId);
  const setFloorplans = props.floorPlans[1];
  const findCurrentMerchant = props.findMerchant;
  const getDialogState = props.dialogState;
  const getSelectedFloorplan = props.selectedFloorplan;

  function removeFloorplan() {
    const floorplan_index = getSelectedFloorplan().index;
    _delete("/nova/sp_merchant/" + spMerchantId + "/floorplan/" + floorplan_index)
      .catch((e) => {
        toast.error("Removal of floor plan was unsuccessful.", {
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setFloorplans(JSON.parse(findCurrentMerchant().floor_plan));
        console.log(e);
        return Promise.reject();
      })
      .then((response) => {
        toast.success("Removed successfully!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        const sp_merchant = findCurrentMerchant();
        sp_merchant.floor_plan = response.data.floor_plan;
        setFloorplans([...JSON.parse(response.data.floor_plan)]);
        dialogClose();
      });
  }

  return (
    <Dialog
      open={getDialogState()}
      onClose={() => {
        dialogClose(null);
      }}
    >
      <DialogTitle>Adding floor plans</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to remove{" "}
          {getSelectedFloorplan() ? getSelectedFloorplan().floorplan.name : "unknown floor plan"}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            dialogClose(null);
          }}
          color="primary"
        >
          Cancel
        </Button>
        <Button
          onClick={(_) => {
            removeFloorplan();
          }}
          color="primary"
        >
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}
